// src/analysis/conteoPalmas/conteoPalmasValidation.jsx

export const validateConteoAgavesData = (datosAnalisis) => ({
    conteoAgaves: datosAnalisis.conteoAgaves?.valor && datosAnalisis.conteoAgaves?.valor !== 0,
    precioPlantacion: datosAnalisis.precioPlantacion?.valor && datosAnalisis.precioPlantacion?.valor !== 0,
    costosPlantacion: datosAnalisis.costosPlantacion?.valor && datosAnalisis.costosPlantacion?.valor !== 0,
    utilidadNeta: datosAnalisis.utilidadNeta?.valor && datosAnalisis.utilidadNeta?.valor !== 0
});
